export const DEFAULT_SERVICE = 'rtlplus_root';
